import {
  AfterViewChecked, AfterViewInit,
  Component,
  ElementRef,
  Input, OnChanges, OnDestroy,
  Renderer2, RendererStyleFlags2, SimpleChanges,
  ViewChild,
} from '@angular/core';
import {AbstractControl, FormControl} from '@angular/forms';
import {DxHtmlEditorComponent} from 'devextreme-angular';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-comments-control',
  templateUrl: './comments-control.component.html',
  styleUrls: ['./comments-control.component.scss'],
})
export class CommentsControlComponent implements AfterViewInit, AfterViewChecked, OnChanges, OnDestroy {
  @Input() public label?: string;
  @Input() public simpleMode = false;
  @Input() public disabled = false;
  @Input() public control: AbstractControl | null = null;
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('container', {static: true}) public containerDiv?: ElementRef;
  @ViewChild('controls', {static: true}) public controlsDiv?: ElementRef;
  @ViewChild('editor', {static: true}) public editor?: DxHtmlEditorComponent;
  @Input() public value = '';
  @Input() public valueChange = false;

  constructor(private renderer: Renderer2, private elem: ElementRef) {
  }

  public ngAfterViewChecked(): void {
    if (this.editor)
      this.editor.height = this.GridSize;

    const elements = (this.elem.nativeElement as HTMLElement)
      .getElementsByClassName('dx-toolbar-items-container') as HTMLCollectionOf<HTMLElement>;

    // tslint:disable-next-line:no-bitwise
    const flags = RendererStyleFlags2.DashCase | RendererStyleFlags2.Important;
    if (elements) {
      for (let i = 0; i < elements.length; i++) {
        this.renderer.setStyle(elements.item(i), 'height', 'auto', flags);
      }
    }

    const containerElement = (this.elem.nativeElement as HTMLElement).getElementsByClassName('ql-editor') as HTMLCollectionOf<HTMLElement>;
    if (containerElement) {
      for (let i = 0; i < containerElement.length; i++) {
        this.renderer.setStyle(containerElement.item(i), 'text-transform', 'uppercase');
      }
    }
  }

  public setHtmlValue(value: string) {
    this.valueChange = true;
    value = `<html lang="eng"><head><title></title></head><body>${value === null ? '' : value}</body></html>`;
    this.control?.setValue(value);
  }

  public htmlChanged(value: any) {
    value = `<html lang="eng"><head><title></title></head><body>${value === null ? '' : value}</body></html>`;
    this.valueChange = false;
    this.control?.setValue(value);
  }

  public get GridSize() {
    const element = this.containerDiv?.nativeElement as HTMLElement;
    return element?.getBoundingClientRect().height -
      36 - element?.getBoundingClientRect().height;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (this.editor?.instance && this.control && this.control.value) {
      this.editor.instance.option('value', this.control.value);
    }
  }

  public ngAfterViewInit(): void {
    this.control?.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe(value => {
      if (this.valueChange && this.editor?.instance && this.control && this.control.value) {
        this.editor.instance.option('value', value);
      }
    });
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
